import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-counters-type01',
  standalone: true,
  imports: [MatIconModule],
  templateUrl: './counters-type01.component.html',
  styleUrl: './counters-type01.component.scss'
})
export class CountersType01Component {

}
